import HomeIcon from '../../icons/home.svg?react';
import ProductsIcon from '../../icons/products.svg?react';
import { QuoterManagementPath } from '../../Routes';

const layOutNavLink = () => [
  {
    text: 'Home',
    link: '/',
    icon: HomeIcon,
    isActive: false,
    isHide: false
  },
  {
    text: 'Quoter Management',
    link: QuoterManagementPath,
    icon: ProductsIcon,
    isActive: false,
    isHide: false
  }
];

const setDefaultLinks = () => {
  let navLinksList = layOutNavLink();

  let links = navLinksList.filter((links) => !links.isHide);
  links.forEach((part, index, array) => { array[index].isActive = false; });

  let currentURL = window.location.href.split('/');

  currentURL = currentURL.map((url) => url.split("?")[0]);

  currentURL.forEach((linkSegment, i) => {
    let activeNavItem = links.find(item => item.link.replace('/', '') === linkSegment);

    if (activeNavItem) {
      activeNavItem.isActive = true;
    }
  });

  let activeItems = links.filter(item => item.isActive === true);

  if (activeItems.length > 1) {
    links = links.map(item => item.text === 'Home' ? { ...item, isActive: false } : item);
  }

  return links;
}

export { setDefaultLinks }
